import type { IAppThunk } from "../app/store";
import { RoomSideBarTabs } from "@multiconsult-group/multiplacer-core";
import { setActiveRoomColoringIdThunk } from "../DesignTab/designThunk";
import { selectAvailableStandardRoomValidationDisciplines } from "../Room/roomSelectors";
import { DROFUS_OCCURRENCE_VALIDATION_OVERALL_ID } from "../DrofusOccurrenceValidation/drofusOccurrenceValidationIds";
import { validationTabForColor } from "./validationPanelTabs";
import {
  selectDrofusOccurrenceValidationListType,
  selectDrofusOccurrenceValidationResponsibility,
  selectDrofusOccurrenceValidationFilterMode,
  makeDrofusOccurrenceValidationListTypeColoringId,
  makeDrofusOccurrenceValidationResponsibilityColoringId,
} from "../DesignTab/ModuleBars/DrofusOccurrenceValidationBarSelectors";
import {
  setDrofusOccurrenceValidationFilterModeInRedux,
  setDrofusOccurrenceValidationListTypeInRedux,
  setDrofusOccurrenceValidationResponsibilityInRedux,
} from "../DrofusOccurrenceValidation/drofusOccurrenceValidationSlice";
import {
  setActiveRoomColoringIdInRedux,
  setDrofusStandardRoomDisciplineInRedux,
  type IDrofusStandardRoomDiscipline,
} from "../DesignTab/designSlice";

export const selectValidationViewThunk =
  (tab: RoomSideBarTabs): IAppThunk =>
  (dispatch, getState) => {
    const state = getState();
    if (validationTabForColor(state.design.activeRoomColoringId) === tab) return;
    const color =
      tab === RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES
        ? DROFUS_OCCURRENCE_VALIDATION_OVERALL_ID
        : `standardRoom.${selectAvailableStandardRoomValidationDisciplines(state)[0] ?? "E"}`;
    dispatch(setActiveRoomColoringIdThunk(color));
  };


export const changeOccurrenceFilterValueThunk =
  (value: string | null): IAppThunk =>
  (dispatch, getState) => {
    const listMode = selectDrofusOccurrenceValidationFilterMode(getState()) === "listType";
    dispatch(setDrofusOccurrenceValidationListTypeInRedux(listMode ? value : null));
    dispatch(setDrofusOccurrenceValidationResponsibilityInRedux(listMode ? null : value));
    dispatch(
      setActiveRoomColoringIdThunk(
        value
          ? listMode
            ? makeDrofusOccurrenceValidationListTypeColoringId(value)
            : makeDrofusOccurrenceValidationResponsibilityColoringId(value)
          : DROFUS_OCCURRENCE_VALIDATION_OVERALL_ID
      )
    );
  };
export const changeOccurrenceFilterModeThunk =
  (value: string): IAppThunk =>
  (dispatch, getState) => {
    const mode = value === "responsibility" ? "responsibility" : "listType";
    const state = getState();
    const next =
      mode === "listType"
        ? selectDrofusOccurrenceValidationListType(state)
        : selectDrofusOccurrenceValidationResponsibility(state);
    dispatch(setDrofusOccurrenceValidationFilterModeInRedux(mode));
    dispatch(changeOccurrenceFilterValueThunk(next));
  };

export const changeStandardRoomDisciplineThunk =
  (value: string): IAppThunk =>
  (dispatch, getState) => {
    const prefix = getState().design.activeRoomColoringId?.startsWith("decision:")
      ? "decision:"
      : "";
    dispatch(setActiveRoomColoringIdInRedux(`${prefix}standardRoom.${value}`));
    dispatch(
      setDrofusStandardRoomDisciplineInRedux(
        `standardRoom.${value}` as IDrofusStandardRoomDiscipline
      )
    );
  };
